import * as React from 'react';

import { useApplicationContext, useNotAvailablePopupContext } from '../context';
import { useOfferContext } from '../containers/OfferContext';
import { ECategory } from '../types';
import { fetchComagic } from '../services/fetchComagic';

export function useCall(onClick?: () => void) {
  const { logger, httpApi } = useApplicationContext();

  const { openNotAvailablePopup } = useNotAvailablePopupContext();

  const offer = useOfferContext();
  const {
    phones,
    calltracking: { siteBlockId },
    author,
    category,
  } = offer;
  const { isFromLeadFactory, agentAvailability, isChatsEnabled } = author;

  const phone = phones && phones.length ? phones[0] : null;

  const isCalltrackingEnabled = React.useMemo(
    () => category !== ECategory.NewBuildingFlatSale && offer.isCalltrackingEnabled,
    [category, offer],
  );

  const produceCall = React.useCallback(
    (phone: string, forceCall = false) => {
      if (agentAvailability && !agentAvailability.available && isChatsEnabled && !forceCall) {
        openNotAvailablePopup();

        return;
      }

      window.location.href = `tel:${phone}`;
    },
    [agentAvailability, isChatsEnabled, openNotAvailablePopup],
  );

  const loadComagicPhone = React.useCallback(
    function () {
      return fetchComagic(
        { comagicId: siteBlockId, placeType: 'stickyBottom', announcementId: offer.id },
        { logger, httpApi },
      );
    },
    [siteBlockId, offer.id, httpApi, logger],
  );

  const handleCall = React.useCallback(async () => {
    if (phone === null) {
      return;
    }

    const comagicPhone = await loadComagicPhone();

    if (!isFromLeadFactory) {
      produceCall(comagicPhone || phone);
    }

    if (onClick) {
      onClick();
    }
  }, [phone, loadComagicPhone, isFromLeadFactory, onClick, produceCall]);

  return React.useMemo(
    () => ({
      handleCall,
      loadComagicPhone,
      produceCall,
      phone,
      isLeadFactory: isFromLeadFactory,
      isCalltrackingEnabled,
    }),
    [handleCall, loadComagicPhone, produceCall, phone, isFromLeadFactory, isCalltrackingEnabled],
  );
}
